import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Loading from "../../components/Loading/loading";
import { useDispatch, useSelector } from "react-redux";
import "./StudentAsign.css";
import { clearError, getStudent, studentdAsign, studentdUpdate } from "../../actions/fileAction";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { STUDENT_ASIGN_RESET, STUDENT_UPDATE_RESET } from "../../constants/fileConstant";
import { getAllUsers } from "../../actions/userAction";
import { MdOutlineDoNotDisturb } from "react-icons/md";

const StudentAsign = () => {
    const [userId, setUserId] = useState();

  const dispatch = useDispatch();
  const { error, isAsigned, message, loading } = useSelector(
    (state) => state.asign
  );
  const { error:studentEroor, student, loading:studentLoading } = useSelector(
    (state) => state.oneStudent
  );
  const { error:allUserErroe, users, loading:allUserLoading } = useSelector(
    (state) => state.allUsers
  );
  const { user } = useSelector(
    (state) => state.users
  );

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
      // setSelectedMultiFile([])
    }
    if (studentEroor) {
        toast.error(studentEroor);
        dispatch(clearError());
        // setSelectedMultiFile([])
      }
      if (allUserErroe) {
        toast.error(allUserErroe);
        dispatch(clearError());
        // setSelectedMultiFile([])
      }
    if (isAsigned) {
      toast.success(message);
      navigate("/student/application");
      dispatch({ type: STUDENT_ASIGN_RESET });
      // setSelectedMultiFile([])
    }
    dispatch(getStudent(id))
    dispatch(getAllUsers())
  }, [error, isAsigned, dispatch]);

  const studentAsignHandler = (e) => {
    e.preventDefault()
    console.log(id,userId)
    dispatch(studentdAsign(userId,id))
  };

  // console.log(student)
let usersAs = [];

users && users.forEach(item => {
  if(user.role === 'admin'){
    if(item.role !== 'superviser'){
      usersAs.push(item)
    }
  }else if(user.role === 'lead-counsellor'){

    if(item.role !== 'superviser' && item.role !== 'admin' ){
        if(item.region === user.region){
          usersAs.push(item)
        }
    }

  }
});
  return (
    <div className="dashboardMain">
      <div
        className={
          window.innerWidth > 600 ? "menuContainer show" : "menuContainer hide"
        }
      >
        <Sidebar />
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className="dashboardContainer">
          {/* <DashboardHeader heading={"Students Application"} /> */}

          <div className="StudentAsignBox">
            <form action="" onSubmit={studentAsignHandler}>
              <h3>Student Doucement Update</h3>

              <div className="inputItem">
                <p>Assignment User</p>
                <select required value={userId} onChange={e=>setUserId(e.target.value)}  className="inpBtn">
                  <option value="">Select User</option>
                  {
                    usersAs && usersAs?.map((item)=>(
                      <>
                        {
                          // item.role !== "superviser" && 
                            <option value={item._id}>{item.name} , {item.role} </option>
                        }
                      </>

                    ))
                  }
                </select>
              </div>

              <div className="submitItem">
                <input type="submit" value={"Update"} />
              </div>

              {
                 student && student.assignUser?.length !== 0 ? (
                  <div className="asignHisContainer">
                  <div className="heading">
                    <h3 className="btc1">User</h3>
                    <h3 className="btc2">Date</h3>
                  </div>
                  {/* <div className="asignItem">
                    <h3>Ravi Gupta</h3>
                    <h3>5/01/24</h3>
                  </div> */}
                  
                  {
                      student && student.assignUser?.map((item)=>(
                  <div className="asignItem">
                    <h3>{item.userName}</h3>
                    <h3>{item.assigndAt}</h3>
                  </div>
                      ))
                  }
                </div>
                 ) : <div className="noUserAsignBox">
                        <MdOutlineDoNotDisturb/>
                        <h2>Not Asign</h2>
                 </div>
              }
             
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentAsign;
